module.exports = __webpack_public_path__ + "img/iconmonstr-arrow-65.838f7d4b.svg";